import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../CSS/Modal.css'; // Add custom styles for the modal

const EmailFormOrgModal = ({ isOpen, onClose, orgName }) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_dhgtf7o', 'template_2oqlyys', form.current, 'CSxb2cjoKlU_BpSCG')
      .then((result) => {
        
        form.current.reset(); // Clear the form upon successful submission
        onClose(); // Close the modal
      })
      .catch((error) => {
        console.log(error.text);
      });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Contact Us</h2>
        <form ref={form} onSubmit={sendEmail} className="email-form">
          <div className="form-row-modal">
            <label className="form-label-modal">Reason for Contact:</label>
            <input
              type="text"
              name="reason"
              className="form-input"
              value="Profile – Organization"
              readOnly
            />
          </div>
          <div className="form-row-modal">
            <label className="form-label-modal">Name:</label>
            <input type="text" name="user_name-modal" className="form-input-modal" required />
          </div>
          <div className="form-row-modal">
            <label className="form-label-modal">Email:</label>
            <input type="email" name="user_email" className="form-input-modal" required />
          </div>
          <div className="form-row-modal">
            <label className="form-label-modal">Company:</label>
            <input type="text" name="company" className="form-input-modal" required />
          </div>
          <div className="form-row-modal">
            <label className="form-label-modal">Deadline:</label>
            <input type="text" name="deadline" className="form-input-modal" required />
          </div>
          {/* Subject */}
          <div className="form-row-modal">
            <label className="form-label-modal">Subject:</label>
            <input
              type="text"
              name="subject"
              className="form-input-modal"
              defaultValue={`Profile Creation - (Enter Name of Group)`} // Prefilled value but editable
              required
            />
          </div>
            {/* Message */}
            <div className="form-row-modal">
            <label className="form-label-modal">Message:</label>
            <textarea
              name="message"
              className="form-textarea-modal"
              rows={6}
              cols={50}
              defaultValue={`Hello,

I would like a profile of on a group not listed on the Orion platform.
The group of interest is (Enter Group Name).

Thank you`}
required
            />
          </div>
          <div className="form-actions">
            <button type="submit" className="form-submit">Send</button>
            <button type="button" className="form-cancel" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailFormOrgModal;
